import { MINICHEF_SUPPORTED_CHAIN_IDS, isMiniChefChainId, } from 'sushi/config';
import { getMasterChefV1UserPositions, } from '../subgraphs/master-chef-v1';
import { getMasterChefV2UserPositions, } from '../subgraphs/master-chef-v2';
import { getMiniChefUserPositions, } from '../subgraphs/mini-chef';
import { ChainId } from 'sushi/chain';
export async function getChefUserPositions({ chainIds = [ChainId.ETHEREUM, ...MINICHEF_SUPPORTED_CHAIN_IDS], ...variables }, options) {
    const miniChefChainIds = chainIds.filter(isMiniChefChainId);
    const masterChefPromises = chainIds.includes(ChainId.ETHEREUM)
        ? [
            getMasterChefV1UserPositions(variables, options),
            getMasterChefV2UserPositions(variables, options),
        ]
        : [];
    const promises = await Promise.allSettled([
        ...masterChefPromises,
        ...miniChefChainIds.map((chainId) => getMiniChefUserPositions({
            ...variables,
            chainId,
        }, options)),
    ]);
    const data = [];
    const errors = [];
    for (const promise of promises) {
        if (promise.status === 'fulfilled') {
            data.push(...promise.value);
        }
        else {
            errors.push(promise.reason);
        }
    }
    return { data, errors };
}
